/**
 * PublicEndorsements — endorsements the learner published on a public
 * portfolio. The server sends only the endorser's display name, the evidence
 * kind and the date; nothing else is shown.
 */

import { EVIDENCE_KIND_LABELS, type PublicEndorsement } from './endorsementTypes';

export function PublicEndorsements({ endorsements }: { endorsements?: PublicEndorsement[] }) {
  if (!endorsements || endorsements.length === 0) return null;
  return (
    <div className="card" data-testid="public-endorsements">
      <div className="card-header">
        <h2 className="text-lg font-semibold text-gray-900">Manager endorsements</h2>
      </div>
      <div className="card-body">
        <ul className="space-y-2">
          {endorsements.map((e) => (
            <li key={e.id} className="flex items-center justify-between text-sm">
              <span className="font-medium text-gray-900">{e.endorserDisplayName}</span>
              <span className="text-gray-500">
                {EVIDENCE_KIND_LABELS[e.evidenceKind] ?? e.evidenceKind} &middot;{' '}
                {new Date(e.endorsedAt).toLocaleDateString()}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default PublicEndorsements;
